
import React from 'react';
import { Command, CommandGroup, CommandItem } from '@/components/ui/command';
import { History } from 'lucide-react';
import { motion } from 'framer-motion';

interface SearchHistoryProps {
  recentSearches: string[];
  onSelect: (search: string) => void;
}

const SearchHistory: React.FC<SearchHistoryProps> = ({ recentSearches, onSelect }) => {
  if (!recentSearches.length) return null;
  
  return (
    <motion.div
      initial={{ opacity: 0, y: -10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.2 }}
      className="mb-2"
    >
      <CommandGroup heading="Tìm kiếm gần đây">
        {recentSearches.map((search, index) => (
          <CommandItem 
            key={`recent-${index}`}
            value={search}
            onSelect={() => onSelect(search)}
            className="flex items-center gap-2 py-3 cursor-pointer"
          >
            <History size={16} className="text-slate-400" />
            <span>{search}</span>
          </CommandItem>
        ))}
      </CommandGroup>
    </motion.div>
  );
};

export default SearchHistory;
